import {
  parseScheduledEmailPersonalization,
  personalizationStatusLabel,
} from '../../lib/personalization';
import type { ScheduledEmailRow } from './types';

const STATUS_CLASSES: Record<string, string> = {
  pending: 'bg-violet-50 text-violet-700 border-violet-200 dark:bg-violet-900/30 dark:text-violet-200 dark:border-violet-800',
  processing:
    'bg-violet-50 text-violet-700 border-violet-200 dark:bg-violet-900/30 dark:text-violet-200 dark:border-violet-800',
  completed:
    'bg-emerald-50 text-emerald-700 border-emerald-200 dark:bg-emerald-900/30 dark:text-emerald-200 dark:border-emerald-800',
  skipped:
    'bg-amber-50 text-amber-800 border-amber-200 dark:bg-amber-900/30 dark:text-amber-200 dark:border-amber-800',
  failed: 'bg-red-50 text-red-700 border-red-200 dark:bg-red-900/30 dark:text-red-200 dark:border-red-800',
};

export default function PersonalizationStatusPill({ row }: { row: ScheduledEmailRow }) {
  const p = parseScheduledEmailPersonalization(row.personalization);
  if (!p) return null;
  const label = personalizationStatusLabel(p.status);
  if (!label) return null;
  const classes = STATUS_CLASSES[p.status] ?? STATUS_CLASSES.pending;
  return (
    <span
      className={`inline-flex items-center px-1.5 py-0.5 rounded text-[10px] font-medium uppercase tracking-wide border ${classes}`}
      title={
        p.score_at_run != null
          ? `${label} (profile score ${p.score_at_run} at run)`
          : label
      }
    >
      {label}
    </span>
  );
}
